__turbopack_context__.v({
  "className": "tinos_aded00b7-module__tOfH1a__className",
  "variable": "tinos_aded00b7-module__tOfH1a__variable",
});
